import { FSharpException } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Types.js";
import { class_type } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Reflection.js";
import { createAtom } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Util.js";
import { empty } from "../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Extra.fs.js";
import { printf, toText } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/String.js";
import { keyValueList } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { singleton, ofArray, append } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../Bfs.Web.Kundenportal/fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../Bfs.Web.Kundenportal/fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../Bfs.Web.Kundenportal/fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { Cmd_OfPromise_either } from "../Bfs.Web.Kundenportal/fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { FSharpResult$2 } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Result.js";
import { GlobalMessageBox_Error_Z721C83C5, GlobalMsg, Remote$1 } from "./Types.fs.js";

export class UnauthorizedException extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function UnauthorizedException_$reflection() {
    return class_type("Http.UnauthorizedException", undefined, UnauthorizedException, class_type("System.Exception"));
}

export let Encoders = createAtom(empty);

export function errorString(response) {
    let text;
    const arg = (response.status) | 0;
    const arg_1 = response.statusText;
    const arg_2 = response.url;
    text = toText(printf("%i %s for URL %s"))(arg)(arg_1)(arg_2);
    if ((response.status) === 401) {
        throw new UnauthorizedException(text);
    }
    else {
        return text;
    }
}

export function sendJson(url, str, init, httpMethod) {
    const pr = fetch(url, keyValueList(append(ofArray([new Types_RequestProperties(0, [httpMethod]), new Types_RequestProperties(1, [{
        "Content-Type": "application/json",
    }]), new Types_RequestProperties(2, [str])]), init), 1));
    return pr.then((response) => {
        if (!(response.ok)) {
            throw new Error(errorString(response));
        }
        else {
            return response;
        }
    });
}

export function postEmpty(url) {
    return sendJson(url, "", singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function getText(url) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetch(url, {
        credentials: "include",
    }).then((_arg) => (_arg.text().then((_arg_1) => (Promise.resolve(_arg_1))))))));
}

export function request(fetch$, args, message) {
    return Cmd_OfPromise_either(fetch$, args, (arg) => message(new FSharpResult$2(0, [arg])), (arg_1) => message(new FSharpResult$2(1, [arg_1])));
}

export function Loaded(remote) {
    let arg;
    if (remote.tag === 1) {
        const e = remote.fields[0];
        const msg = "[Debug] " + toText(printf("Error when loading:\n %A"))((message) => (new Error(message)));
        if (e.message.indexOf("401") === 0) {
            throw new UnauthorizedException(e.message);
        }
        return new Remote$1(2, [(arg = e.message, toText(printf("Fehler beim Laden (%s)"))(arg))]);
    }
    else {
        return new Remote$1(3, [remote.fields[0]]);
    }
}

export function errorCmd(globalmsgType, text, exn) {
    let arg_1;
    if (exn instanceof UnauthorizedException) {
        const msg = globalmsgType(new GlobalMsg(1, []));
        return singleton((dispatch) => {
            dispatch(msg);
        });
    }
    else {
        const msg_1 = globalmsgType(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5((arg_1 = exn.message, toText(printf("Fehler beim %s: %s"))(text)(arg_1)))]));
        return singleton((dispatch_1) => {
            dispatch_1(msg_1);
        });
    }
}

export function errorCmd2(globalmsgType, text, error) {
    const msg = globalmsgType(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5(toText(printf("Fehler beim %s: %s"))(text)(error))]));
    return singleton((dispatch) => {
        dispatch(msg);
    });
}

//# sourceMappingURL=Http.fs.js.map
